import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypesByEventId } from "ticketino-api-client";
import { Calendar } from "react-calendar";
import parse from "html-react-parser";
import { toZonedTime } from 'date-fns-tz';

import Header from "./components/Header";
import Footer from "./components/Footer";
import "../css/style.css";
import "../css/calendar.css";
import Loading from "./components/Loading";
import voucherimage from "../images/recommendedEvent.jpg";
import masterclassimage from "../images/masterclass.jpg";
import ordrechanneimage from "../images/ordrechanne.jpg";
import piemontimage from "../images/piemont.jpg";
import recommendedEventimage from "../images/recommendedEvent.jpg";

const Home = () => {
    const [date, setDate] = useState(new Date());
    const [posId, setPosId] = useState();
    const [eventId, setEventId] = useState();
    const [events, setEvents] = useState([]);
    const [eventGroupId, setEventGroupId] = useState();
    const [eventDates, setEventDates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [masterclassEventId, setMasterclassEventId] = useState(0);
    const [voucherEventId, setVoucherEventId] = useState(0);

    const timeZone = 'Europe/Zurich';

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching resources
    const { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        case ("it" || "IT"):
            languageId = 4;
            break;
        default:
            languageId = 0;
            break;
    }

    useEffect(() => {
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotions", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        if (eventGroupId) {
            loadEvent(eventGroupId)
        }
    }, [eventGroupId]); //gets called when an order is started


    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID
            setPosId(res.data.posId);
            setEventId(res.data.eventId);
            setEventGroupId(res.data.eventGroupId);
            setMasterclassEventId(res.data.masterEventId);
            setVoucherEventId(res.data.voucherEventId);

            sessionStorage.setItem("masterEventId", res.data.masterEventId);
            sessionStorage.setItem("recommendedWeinschiffeEventId", res.data.recommendedWeinschiffeEventId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventGroupId) => {
        try {
            setLoading(true);

            let updatedEvents = await getEventsByEventGroupId(eventGroupId);

            let datesArray = [];

            updatedEvents.map(event => {
                datesArray.push(event.start?.split('T')[0]);
            });

            updatedEvents = updatedEvents.filter(ue => ue.id != 193133);

            updatedEvents = await Promise.all(updatedEvents.map(async (event) => {
                let ticketTypes = await getTicketTypesByEventId(event.id);
                ticketTypes.sort((a, b) => a.sortOrder - b.sortOrder);

                // Get all prices excluding 19, 3 and 0 CHF
                const validPrices = ticketTypes
                    .filter(tt => tt.isActive && tt.price !== 31.60 && tt.price !== 28.80 && tt.price !== 27.60 && tt.price !== 24.80 && tt.price !== 23.60 && tt.price !== 23.80 && tt.price !== 20 && tt.price !== 19 && tt.price !== 5 && tt.price !== 3 && tt.price !== 0)
                    .map(tt => tt.price);

                const minPrice = Math.min(...validPrices);

                console.log("minPrice");
                console.log(minPrice);

                let classNameColor = "";

                // Set class based on min price
                if (minPrice === 38) {
                    classNameColor = "tickethigherprice";
                } else if (minPrice === 30) {
                    classNameColor = "ticketmediumprice";
                } else if (minPrice === 28) {
                    classNameColor = "ticketsmallerprice";
                }

                return { ...event, color: classNameColor };
            }));

            setEventDates(datesArray);
            setEvents(updatedEvents);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    }


    //const loadEvent = async (eventGroupId, orderId) => {
    //    try {
    //        setLoading(true);

    //        let updatedEvents = await getEventsByEventGroupId(eventGroupId);

    //        let datesArray = [];

    //        updatedEvents.map(event => {
    //            datesArray.push(event.start?.split('T')[0]);
    //        })

    //        updatedEvents = updatedEvents.filter(ue => (ue.id != 193133));

    //        updatedEvents = await Promise.all(updatedEvents.map(async (event) => {
    //            let ticketTypes = await getTicketTypesByEventId(event.id);
    //            ticketTypes.sort((a, b) => a.sortOrder - b.sortOrder);

    //            const ticketTypePrice = ticketTypes[1]?.price;
    //            const ticketTypePrice2 = ticketTypes[2]?.price;

    //            let classNameColor = "";

    //            //if (ticketTypePrice == 33 && ticketTypePrice2 == 28) {
    //            //    classNameColor = "lightgrey"
    //            //} else if (ticketTypePrice == 38 && ticketTypePrice2 == 28) {
    //            //    classNameColor = "blue"
    //            //} else if (ticketTypePrice == 28) {
    //            //    classNameColor = "darkgrey"
    //            //} else if (ticketTypePrice == 30) {
    //            //    classNameColor = "lightgrey"
    //            //} else if (ticketTypePrice == 33) {
    //            //    classNameColor = "lightgreyer"
    //            //} else if (ticketTypePrice == 38) {
    //            //    classNameColor = "darkgrey"
    //            //}

    //            console.log(event.start?.split('T')[0]);
    //            console.log("preis1")
    //            console.log(ticketTypePrice)
    //            console.log("preis2")
    //            console.log(ticketTypePrice2)

    //            if (ticketTypePrice === 38) {
    //                classNameColor = "tickethigherprice"
    //            }
    //            else if (ticketTypePrice === 33) {
    //                classNameColor = "ticketmediumprice"
    //            } else if (ticketTypePrice === 28) {
    //                classNameColor = "ticketsmallerprice"
    //            }

    //            return { ...event, color: classNameColor }
    //        }))

    //        setEventDates(datesArray);
    //        setEvents(updatedEvents);
    //        setLoading(false);
    //    } catch (error) {
    //        console.error(error);
    //    }
    //}

    const getEventsByEventGroupId = async (eventGroupId) => {
        try {
            const res = await axios.get(`${baseUrl}/EventGroup/Events?eventGroupId=${eventGroupId}&languageCode=${language != "de" || language != "fr" || language != "it" || language != "en" ? "de" : language}`);
            return res.data?.events;
        } catch (error) {
            console.error(error);
        }
    }

    const onSubmit = async () => {
        navigate("/tickets");
    };

    const tileClassName = ({ date }) => {
        // Convert date to Zurich time
        const timeZone = 'Europe/Zurich';
        const zurichDate = toZonedTime(date, timeZone);

        // Extract year, month, day manually
        const year = zurichDate.getFullYear();
        const month = String(zurichDate.getMonth() + 1).padStart(2, '0'); // Ensure two digits
        const day = String(zurichDate.getDate()).padStart(2, '0'); // Ensure two digits

        // Format "YYYY-MM-DD"
        const formattedDate = `${year}-${month}-${day}`;

        if (eventDates.includes(formattedDate)) {
            const event = events.find(e => e.start?.split('T')[0] === formattedDate);
            return `bold-date ${event?.color} ${language}${event?.color}`;
        } else {
            return 'disabled-date';
        }
    };

    //const tileClassName = ({ date }) => {
    //    const dateString = new Date(date);
    //    dateString.setDate(dateString.getDate() + 1);
    //    const formattedDate = dateString.toISOString().split('T')[0];

    //    if (eventDates.includes(formattedDate)) {
    //        let selectedDate = new Date(date);
    //        selectedDate.setDate(selectedDate.getDate() + 1);
    //        const formattedDate = selectedDate.toISOString().split('T')[0];
    //        const event = events.find(e => e.start?.split('T')[0] == formattedDate);

    //        return `bold-date ${event?.color} ${language}${event?.color}`;
    //    } else {
    //        return 'disabled-date';
    //    }
    //};

    const onClickDay = (date) => {
        const timeZone = 'Europe/Zurich';
        const zurichDate = toZonedTime(date, timeZone);

        // Extract year, month, day manually
        const year = zurichDate.getFullYear();
        const month = String(zurichDate.getMonth() + 1).padStart(2, '0'); // Two-digit month
        const day = String(zurichDate.getDate()).padStart(2, '0'); // Two-digit day

        // Format "YYYY-MM-DD"
        const formattedDate = `${year}-${month}-${day}`;

        const event = events.find(e => e.start?.split('T')[0] === formattedDate);

        if (event?.id > 0) {
            navigate(`/${language}/event/${event.id}`);
        }
    };

    //const onClickDay = (date) => {
    //    let selectedDate = new Date(date);
    //    selectedDate.setDate(selectedDate.getDate() + 1);
    //    const formattedDate = selectedDate.toISOString().split('T')[0];

    //    const event = events.find(e => e.start?.split('T')[0] == formattedDate);

    //    if (event?.id > 0) {
    //        navigate(`/${language}/event/${event.id}`);
    //    }
    //}

    const activeStartDate1 = new Date(Date.UTC(2025, 9, 1, 12, 0, 0)); // Set time to noon UTC to avoid date shift
    const activeStartDate2 = new Date(Date.UTC(2025, 10, 1, 12, 0, 0)); // Set time to noon UTC to avoid date shift

    return (
        <div className="container wrapper">
            <Header resources={resources} showLanguage={true} recommendedEventsHeader={false} />
            <div className="mt-4">
                <div className="mb-4 times-container">
                    <div className="row times">
                        <p className="text fs-6 fw-bold mb-2">{resources?.OpeningTimesTitle}</p>
                        {parse(resources?.OpeningTimes1 ?? "")}
                        {parse(resources?.OpeningTimes2 ?? "")}
                        {parse(resources?.OpeningTimes3 ?? "")}
                        {parse(resources?.OpeningTimes4 ?? "")}

                        <div className="mt-2" dangerouslySetInnerHTML={{ __html: resources?.OpeningTimesSecurity }}></div>
                        
                    </div>
                </div>
                {!loading ? <div>
                    <p className="fs-6 text-container mb-3">{resources?.SelectDate}</p>
                    <div className="calendar-container mb-2">
                        <Calendar
                            activeStartDate={activeStartDate1}
                            view="month"
                            value={date}
                            onChange={setDate}
                            tileClassName={tileClassName}
                            onClickDay={onClickDay}
                            locale={language}
                            showNeighboringMonth={false}
                        />
                        <Calendar
                            activeStartDate={activeStartDate2}
                            view="month"
                            value={date}
                            onChange={setDate}
                            tileClassName={tileClassName}
                            onClickDay={onClickDay}
                            locale={language}
                            showNeighboringMonth={false}
                        />
                    </div>
                    <div className="row">
                        <div className="col">
                            <p className="text-start mb-2" style={{ fontSize: "small", color: "#25536D" }}>{parse(resources?.Note1 ?? "")}</p>
                            <p className="text-start mb-4" style={{ fontSize: "small", color: "#25536D" }}>{parse(resources?.Note2 ?? "")}</p>
                        </div>
                        <div className="col">
                            <p className="text-end mb-4" style={{ fontSize: "small", color: "#25536D" }}>{resources?.Note}</p>
                        </div>
                    </div>
                </div> : <Loading bgColor="#fff" color="#25536D" />}
                <div className="row text-start">
                    <div className="col-md-5 col-12 text-center">
                        <img className="img-fluid" src={voucherimage}></img>
                    </div>
                    <div className="col-md-7 col-12 description-div">
                        <div>
                            <label className="fw-bold">
                                {resources?.GiftVoucher}
                            </label>
                        </div>
                        <p>{parse(resources.VoucherDesc ?? "")}</p>
                        <div className="text-end description-div-button">
                            <button className="button text-end" onClick={() => navigate(`/${language}/event/${voucherEventId}`)}>{resources?.BookVoucher}</button>
                        </div>
                    </div>
                </div>
                <div className="row text-start mt-5">
                    <div className="col-md-5 col-12 text-center">
                        <img className="img-fluid" src={masterclassimage} alt="masterclass"></img>
                    </div>
                    <div className="col-md-7 col-12 description-div">
                        <div>
                            <label className="fw-bold">
                                {resources?.ComingSoonMasterClasses}
                            </label>
                        </div>
                        <div><p>{parse(resources.MasterclassDesc ?? "")}</p></div>
                        <div className="text-end description-div-button">
                            {/*<div>*/}
                            {/*    <a className="button masterclass-btn text-center" href={`https://www.ticketino.com/${language}/event/Expovina-Primavera/${masterclassEventId}`}>{resources?.BookTickets}</a>*/}
                            {/*</div>*/}
                            <div className="mt-1">
                                <a className="button masterclass-btn text-center" href={resources.MasterClassesMoreInfoUrl} >{resources?.LearnMore}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row text-start mt-5">
                    <div className="col-md-5 col-12 text-center">
                        <img className="img-fluid" src={ordrechanneimage} alt="Ordre de la Channe"></img>
                    </div>
                    <div className="col-md-7 col-12 description-div">
                        <div>
                            <label className="fw-bold">
                                {resources?.OrdreChanne}
                            </label>
                        </div>
                        <div><p>{parse(resources.OrdreChanneDesc ?? "")}</p></div>
                        <div className="text-end description-div-button">
                            <div className="mt-1">
                                <a className="button masterclass-btn text-center" href={resources.OrdreChanneMoreInfoUrl} >{resources?.LearnMore}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row text-start mt-5">
                    <div className="col-md-5 col-12 text-center">
                        <img className="img-fluid" src={piemontimage} alt="Piemont"></img>
                    </div>
                    <div className="col-md-7 col-12 description-div">
                        <div>
                            <label className="fw-bold">
                                {resources?.Piemont}
                            </label>
                        </div>
                        <div><p>{parse(resources.PiemontDesc ?? "")}</p></div>
                        <div className="text-end description-div-button">
                            <div className="mt-1">
                                <a className="button masterclass-btn text-center" href={resources.PiemontMoreInfoUrl} >{resources?.LearnMore}</a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className="row text-start mt-5">*/}
                {/*    <div className="col-md-5 col-12 text-center">*/}
                {/*        <img className="img-fluid" src={recommendedEventimage}></img>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-7 col-12 description-div">*/}
                {/*        <div>*/}
                {/*            <label className="fw-bold">*/}
                {/*                {resources?.ComingSoonEvents}*/}
                {/*            </label>*/}
                {/*        </div>*/}
                {/*        <div dangerouslySetInnerHTML={{ __html: resources?.EventsDesc }}></div>*/}
                {/*        <div className="text-end description-div-button">*/}
                {/*            */}{/*<div>*/}
                {/*            */}{/*    <a className="button masterclass-btn text-center" href={resources?.BookWeinschiffeEventUrl}>{resources?.BookTickets}</a>*/}
                {/*            */}{/*</div>*/}
                {/*            */}{/*<div className="mt-1">*/}
                {/*            */}{/*    <a className="button masterclass-btn text-center" href=" https://expovina.ch/de-ch/weinschiff/klubschiff">{resources?.LearnMore}</a>*/}
                {/*            */}{/*</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="text-start mt-4 mb-4">
                    <a className="button text-start" href="https://expovina.ch/de-ch/primavera">
                        {resources?.Back}
                    </a>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home